import React from "react";
import { Controller } from "react-hook-form";

const MultiplayCheckBoxPreSelection = ({
  name,
  mapitems,
  control,
  errors,
  label,
  selectedValues,
  items,
  isMandatory,
  isRequired,
}) => {
  return (
    <div>
      {/* Label */}
      <div className="xs:text-sm sm:text-base font-onestRegular text-secondary flex justify-start items-center">
        <div>{label}</div>
        <p className="text-errorRed pl-1 text-lg leading-3">
          {isMandatory ? "*" : ""}
        </p>
      </div>
      {/* Job Selection */}
      <Controller
        name={name}
        control={control}
        defaultValue={selectedValues?.map((item) => item?.id) || []} // Extract correct ID
        rules={isRequired ? { required: `${label} selection is required` } : {}}
        render={({ field }) => {
          // Ensure field.value is an array
          const fieldValue = field.value || [];

          return (
            <div className="flex items-center flex-wrap gap-x-4 gap-y-2 pt-2 max-h-[250px] overflow-y-auto dashboard-scrollbar">
              {mapitems?.map((value) => {
                const isChecked = fieldValue.includes(value.id); // Check if it's in the controlled state

                return (
                  <label
                    key={value?.id}
                    className="custom-radio cursor-pointer flex justify-center items-center md:text-[17px] text-[18px] 3xl:text-[20px] font-raleway"
                  >
                    <input
                      type="checkbox"
                      value={value?.id}
                      checked={isChecked}
                      onChange={(e) => {
                        let newValue = [...fieldValue];

                        if (e.target.checked) {
                          newValue.push(value.id);
                        } else {
                          newValue = newValue.filter((id) => id !== value.id);
                        }

                        field.onChange(newValue);
                      }}
                      className="hidden peer"
                    />
                    <span className="w-7 h-7 inline-block bg-[#212121] rounded-[3px] peer-checked:bg-goldMetallic peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-black peer-checked:after:text-center peer-checked:after:leading-7"></span>
                    <p className="font-onestRegular xs:text-sm sm:text-lg text-secondary ml-2">
                      {value?.[items]}
                    </p>
                  </label>
                );
              })}
            </div>
          );
        }}
      />

      {/* Error Message */}
      <div className="flex justify-start items-center pt-1">
        {errors[name] && (
          <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
            {errors[name].message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MultiplayCheckBoxPreSelection;
